export const skillsData = [
  { title: "Ruby On Rails", percent: 90, className: "ruby_on_rails" },
  { title: "JavaScript", percent: 70, className: "javascript" },
  { title: "JQuery", percent: 70, className: "jquery" },
  { title: "ReactJS", percent: 60, className: "reactjs" },
  { title: "NodeJS", percent: 60, className: "nodejs" },
  { title: "PostgreSQL", percent: 80, className: "postgresql" },
  { title: "MongoDB", percent: 70, className: "mongodb" },
  { title: "Bootstrap", percent: 70, className: "bootstrap" },
  { title: "HTML & CSS", percent: 70, className: "htmlcss" },
];
